/* ==========================================================================
   TNF · Google-Bewertung aktualisieren
   --------------------------------------------------------------------------
   Die Zahlen stehen bereits serverseitig im HTML. Dieses Script holt nur die
   aktuellen Werte nach und korrigiert sie, falls sie abweichen.

   - laeuft nur, wenn im Snippet ein Endpunkt hinterlegt ist
   - eine Anfrage pro Seitenaufruf, am Edge zwischengespeichert
   - faellt der Endpunkt aus, bleibt die serverseitige Anzeige stehen
   ========================================================================== */
(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-tnf-rating]');
  if (!nodes.length) return;

  var endpoint = nodes[0].getAttribute('data-tnf-endpoint');
  if (!endpoint) return;

  fetch(endpoint, { mode: 'cors', credentials: 'omit' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || typeof d.rating !== 'number' || typeof d.count !== 'number') return;
      var rating = Math.round(d.rating * 10) / 10;
      var text = String(rating).replace('.', ',');
      Array.prototype.forEach.call(nodes, function (el) {
        var v = el.querySelector('[data-tnf-rating-value]');
        var c = el.querySelector('[data-tnf-rating-count]');
        var s = el.querySelector('[data-tnf-rating-stars]');
        if (v) v.textContent = text;
        if (c) c.textContent = d.count;
        if (s) s.style.width = (rating * 20) + '%';
        el.setAttribute('aria-label',
          'Google-Bewertung: ' + text + ' von 5 Sternen aus ' + d.count +
          ' Bewertungen. Öffnet das Google-Profil in einem neuen Tab.');
      });
    })
    .catch(function () {});
})();
